import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  where,
  orderBy,
  getDocs,
  doc,
  updateDoc,
} from 'firebase/firestore';
import { db } from '../firebase';
import { getAuth } from 'firebase/auth';
import { ARTIFACT_TYPES } from '../../features/artifacts/artifactTypes';
// moved to ./repository/create
import { createIncidentWithSmartFollowUp } from './repository/create';
// import { writeBatch } from 'firebase/firestore'; // unused
import {
  recordFollowUpResponse,
  getFollowUpSummary,
  forceCompleteFollowUp,
  getIncidentsPendingFollowUp,
} from './repository/followUps';
import { getIncidents } from './repository/queries';

// re-exported at bottom

// Get custom categories for a child
export const getCustomCategories = async (childId) => {
  try {
    const q = query(
      collection(db, 'children', childId, 'customIncidentCategories'),
      orderBy('createdAt', 'desc')
    );

    const querySnapshot = await getDocs(q);
    const categories = {};

    querySnapshot.docs.forEach((d) => {
      categories[d.data().key] = {
        id: d.id,
        ...d.data(),
      };
    });

    return categories;
  } catch (error) {
    console.error('Error fetching custom categories:', error);
    return {};
  }
};

export const addIncident = async (childId, incidentData) => {
  try {
    // Get current user for audit metadata
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      throw new Error('User must be authenticated to add incidents');
    }

    const docData = {
      // Required immutable metadata for security rules
      childId,
      createdBy: currentUser.uid,
      createdAt: serverTimestamp(),
      
      // Incident data
      artifactType: ARTIFACT_TYPES.TIMELINE_EVENT,
      type: incidentData.type,
      customIncidentName: incidentData.customIncidentName || '',
      severity: incidentData.severity,
      remedy: incidentData.remedy,
      triggerSummary: incidentData.triggerSummary || '',
      customRemedy: incidentData.customRemedy || '',
      notes: incidentData.notes || '',
      timestamp: incidentData.incidentDateTime || serverTimestamp(),
      entryDate: incidentData.incidentDateTime
        ? incidentData.incidentDateTime.toDateString()
        : new Date().toDateString(),
      
      // Legacy author fields (keeping for backwards compatibility)
      authorId: incidentData.authorId || currentUser.uid,
      authorName: incidentData.authorName,
      authorEmail: incidentData.authorEmail,
      
      // Follow-up data
      followUpScheduled: incidentData.followUpScheduled || false,
      followUpTime: incidentData.followUpTime || null,
      effectiveness: null,
      followUpCompleted: false,
      
      // Status for soft delete system
      status: 'active',
    };
    const docRef = await addDoc(collection(db, 'incidents'), docData);

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('captureez:timeline-entry-created', {
        detail: {
          id: docRef.id,
          childId,
          collection: 'incidents',
          type: docData.type,
          timelineType: 'incident',
          category: 'incident',
          title: docData.customIncidentName || 'Behavior Incident',
          content: docData.notes || docData.remedy || 'Incident logged',
          notes: docData.notes || '',
          triggerSummary: docData.triggerSummary || '',
          timestamp: docData.timestamp,
          authorId: docData.authorId,
          authorName: docData.authorName,
          authorEmail: docData.authorEmail,
          color: '#F5BED5',
          icon: '🌋',
          incidentData: {
            severity: docData.severity,
            remedy: docData.remedy,
            triggerSummary: docData.triggerSummary,
            customRemedy: docData.customRemedy,
            notes: docData.notes,
            followUpScheduled: docData.followUpScheduled,
            followUpCompleted: docData.followUpCompleted,
            followUpResponses: [],
          },
        },
      }));
    }
    return docRef.id;
  } catch (error) {
    console.error('Error adding incident:', error);
    throw error;
  }
};

export const updateIncidentEffectiveness = async (
  incidentId,
  effectiveness,
  followUpNotes = ''
) => {
  try {
    // Get current user for audit metadata
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      throw new Error('User must be authenticated to update incidents');
    }

    const incidentRef = doc(db, 'incidents', incidentId);
    await updateDoc(incidentRef, {
      effectiveness,
      followUpNotes,
      followUpCompleted: true,
      followUpTimestamp: serverTimestamp(),
      // Required audit fields for security rules
      updatedBy: currentUser.uid,
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error('Error updating incident effectiveness:', error);
    throw error;
  }
};

// Re-export moved functions to keep public API stable
export { createIncidentWithSmartFollowUp };
export { recordFollowUpResponse, getFollowUpSummary, forceCompleteFollowUp, getIncidentsPendingFollowUp, getIncidents };
